import { render, staticRenderFns } from "./TransferRequestTable.vue?vue&type=template&id=1fc0ed96&scoped=true&"
import script from "./TransferRequestTable.vue?vue&type=script&lang=js&"
export * from "./TransferRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./TransferRequestTable.vue?vue&type=style&index=0&id=1fc0ed96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc0ed96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
